var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("selector", {
        staticClass: "mb-4",
        attrs: { items: _vm.listDeselected },
        on: { selected: _vm.select }
      }),
      _vm.label
        ? _c(
            "p",
            {
              staticClass: "ml-3 font-16 font-weight-normal color-secondary-6"
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex flex-wrap" },
        _vm._l(_vm.listSelected, function(item, index) {
          return _c(
            "div",
            { key: item.label },
            [
              _c("chip", {
                attrs: { highlight: "", title: item.label },
                on: {
                  delete: function($event) {
                    return _vm.deselect(item, index)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }